import { Route, Routes } from 'react-router-dom';

import { navigateToMyFiles } from 'router/navigation';

import { ErrorView, IntlErrorBoundary, Sidebar } from '_common/components';

import SearchPage from './pages/SearchPage/SearchPage';

import styles from './SearchContainer.module.scss';

const SearchContainer = () => {
  return (
    <div className={styles.root}>
      <Sidebar />

      <Routes>
        <Route
          index
          element={
            <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
              <SearchPage />
            </IntlErrorBoundary>
          }
        />
        <Route
          path="*"
          element={
            <ErrorView
              error={{
                status: 404,
              }}
              onClick={navigateToMyFiles}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default SearchContainer;
